module.exports = "<button class=button> <span>Close</span> <span class=icon-x></span> </button> ";


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/modal/modal-close/modal-close.template.html
// module id = 560
// module chunks = 0